import { LAYOUT_THEME_KEY } from "../../../themes/manhattan";
import { bookingThemeStyle } from "./bookingTheme.mjs";

/**
 * Exposes `bookingThemeStyle` and `bookingThemeClass` so booking forms follow the active theme,
 * including a layout theme (Manhattan) provided to teleported components.
 */
export default {
    inject: {
        layoutTheme: {
            from: LAYOUT_THEME_KEY,
            default: () => ({ class: null, style: {} }),
        },
    },
    computed: {
        bookingThemeStyle() {
            return bookingThemeStyle(this.$style, this.layoutTheme.style);
        },
        bookingThemeClass() {
            return this.layoutTheme.class;
        },
    },
};
